import { Button } from 'components/Elements';
import { BookOpenIcon, File, Receipt, ThumbsDown, ThumbsUp, X } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { encryptRef } from 'utils/encryption';

export const TransactionDrawerFooter = ({
  actionMessage,
  displayProofOfTransaction,
  handleClose,
  transaction,
  handleApproveTransaction,
  acceptIsLoading,
  denyIsLoading,
  handleProofOfTransactionClick,
  handleDenyTransaction,
}) => {
  const navigate = useNavigate();

  const encRef = encryptRef(transaction?.tx_ref);

  

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex items-center justify-between space-x-2">
        {displayProofOfTransaction ? (
          <Button onClick={handleClose} variant="glass" endIcon={<X />}>
            Close Proof
          </Button>
        ) : (
          <>
            {transaction?.transactionMethod !== 'admin' &&
              transaction.status !== 'successful' &&
              transaction.status !== 'failed' && (
                <>
                  <Button
                    onClick={handleApproveTransaction}
                    disabled={acceptIsLoading}
                    endIcon={<ThumbsUp />}
                    size="sm"
                    variant="inverse"
                    className="bg-green-500 hover:bg-green-600 text-white"
                    isLoading={acceptIsLoading}
                  >
                    Approve
                  </Button>
                  <Button
                    onClick={handleDenyTransaction}
                    disabled={denyIsLoading}
                    size="sm"
                    variant="glass"
                    endIcon={<ThumbsDown />}
                    isLoading={denyIsLoading}
                  >
                    Deny
                  </Button>
                </>
              )}
          </>
        )}
        <Button
          onClick={() => navigate(`/app/transactions/${encRef}`)}
          variant="darkGlass"
          endIcon={<File />}
          size="sm"
        >
          Details
        </Button>
      </div>
    </div>
  );
};
